import '../assets/NcCheckboxRadioSwitch-CaAqi0Jt.css';
import { r } from "./_l10n-BZu8wI2q.mjs";
r();
